/* Stockeados: selector de cantidad + botón con ícono de carrito en las tarjetas de producto
   de TODA la tienda (home, colecciones, búsqueda, carrito). Usa el formulario nativo del tema,
   así el carrito funciona igual. Se carga desde STK Encabezado. */
(function () {
  if (window.__stkCards) return;
  window.__stkCards = true;

  function enhance(root) {
    (root || document).querySelectorAll('.quick-add product-form form').forEach(function (form) {
      if (form.dataset.stkQty) return;
      if (form.closest('quick-add-modal')) return; // ventana de opciones: se deja como viene
      var btn = form.querySelector('button[name="add"]');
      if (!btn || btn.disabled) return;
      form.dataset.stkQty = '1';

      var wrap = document.createElement('div');
      wrap.className = 'stk-buy';
      var qty = document.createElement('div');
      qty.className = 'stk-qty';
      qty.innerHTML =
        '<button type="button" data-d="-1" aria-label="Disminuir cantidad">&minus;</button>' +
        '<input type="number" name="quantity" value="1" min="1" step="1" inputmode="numeric" aria-label="Cantidad">' +
        '<button type="button" data-d="1" aria-label="Aumentar cantidad">+</button>';

      btn.parentNode.insertBefore(wrap, btn);
      wrap.appendChild(qty);
      wrap.appendChild(btn);
      btn.classList.add('stk-buy__btn');

      var input = qty.querySelector('input');
      qty.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-d]');
        if (!b) return;
        var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.d, 10);
        input.value = Math.max(1, v);
      });
      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        input.value = !v || v < 1 ? 1 : v;
      });
    });
  }

  /* Etiqueta de oferta: reemplaza el texto del tema por "OFERTA -29%" calculando el
     descuento con los dos precios que muestra la tarjeta. Configuración: STK Encabezado. */
  function digits(el) {
    if (!el) return 0;
    var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }
  function badges(root) {
    var cfg = window.STK_BADGE;
    if (!cfg) return;
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      var price = card.querySelector('.price--on-sale');
      if (!price || price.classList.contains('price--sold-out')) return;
      var regular = digits(price.querySelector('.price__sale s.price-item--regular, .price__sale s'));
      var sale = digits(price.querySelector('.price__sale .price-item--sale'));
      var pct = regular > 0 && sale > 0 && sale < regular ? Math.round(((regular - sale) * 100) / regular) : 0;
      var text = pct > 0 ? String(cfg.text || '').replace('[X]', pct) : (cfg.fallback || '');
      if (!text) return;
      card.querySelectorAll('.card__badge .badge').forEach(function (b) {
        if (b.dataset.stkSale === text) return;
        b.dataset.stkSale = text;
        b.textContent = text;
        b.classList.add('stk-sale');
      });
    });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { enhance(); badges(); }, 80);
  }

  function init() {
    enhance();
    badges();
    // Tarjetas que el tema carga después (filtros de colección, pestañas, etc.)
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes && list[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { schedule(); });
})();
